module.exports = __webpack_public_path__ + "img/9e6242a.jpg";